
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_8673_59352)"}},[_c('path',{attrs:{"d":"M7.234 0l4.234 7.333H3L7.234 0z","fill":"#E5E5E5"}}),_c('path',{attrs:{"d":"M7.234 16L3 8.667h8.468L7.234 16z","fill":"#858585"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_8673_59352"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h15v16H0z"}})])])])
          )
        }
      }
    